export default {
    namespaced: true,
    state: {
        title: 'GAME STARTS IN',
        gameTimer: 0,
        taggerTime: 0,
        status: "closed",
        taggersLeft: 0,
        coinsCollected: 0,
        score: 0,
    },
    getters: {
        gameTimer: state => {
            return state.gameTimer;
        },
        taggerTime: state => {
            return state.taggerTime;
        },
        status: state => {
            return state.status;
        },
        score: state => {
            return state.score;
        },
        coinsCollected: state => {
            return state.coinsCollected;
        },
        taggersLeft: state => {
            return state.taggersLeft;
        },
        title: state => {
            return state.title;
        }
    },
    mutations: {
        decrementGameTimer(state) {
            state.gameTimer--;
        },
        decrementTaggerTimer(state) {
            state.taggerTime--;
        },
        setValue(state, data) {
            state[data[0]] = data[1];
        },
        increaseCoins(state, data) {
            state.coinsCollected += data;
        },
        increaseScore(state, data) {
            state.score += data;
        },
        setGameEnded(state) {
            state.gameTimer = 0;
            state.taggerTime = 0;
            state.taggersLeft = 0;
            state.coinsCollected = 0;
            state.score = 0;
            state.title = 'GAME STARTS IN';
        },
        setTaggersLeft(state, data) {
            state.gameTimer = (data.taggersLeft+1) * data.taggerTime;
            state.taggersLeft--;
            state.taggerTime = data.taggerTime;
        },
        setTitle(state, data) {
            state.title = data;
        }
    },
    actions: {
        decrementGameTimer({ commit }) {
            commit('decrementGameTimer')
        },
        decrementTaggerTimer({ commit }) {
            commit('decrementTaggerTimer')
        },
        setValue({ commit }, data) {
            commit('setValue', data)
        },
        increaseCoins({ commit }, data) {
            commit('increaseCoins', data)
        },
        increaseScore({ commit }, data) {
            commit('increaseScore', data)
        },
        setGameEnded({ commit }) {
            commit('setGameEnded')
        },
        setTaggersLeft({ commit }, data) {
            commit('setTaggersLeft', data);
        },
        setTitle({ commit }, data) {
            commit('setTitle', data);
        }
    }
};